import gql from 'graphql-tag';

export const DELETE_INTEGRATION_SETTINGS_VALUES = gql`
  mutation DeleteIntegrationSettingsValues($input: DeleteIntegrationSettingsValuesInput!) {
    deleteIntegrationSettingsValues(input: $input)
  }
`;
